import { observable, makeObservable } from 'mobx';
export const FORM_PASSWORD_PLACEHOLDER = '6桁以上のパスワードを入力';
export class PasswordVM {
    constructor() {
        Object.defineProperty(this, "passwordStr", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "passwordValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "isSamePassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        makeObservable(this, {
            passwordStr: observable,
            passwordValid: observable,
            isSamePassword: observable,
        });
    }
    onPasswordChanged(password) {
        this.passwordStr = password;
        this.passwordValid = password.length >= 6;
    }
    get isPasswordInvalid() {
        return !this.passwordValid;
    }
}
